export enum SessionsTab {
  All = "All",
  Open = "Open",
  Closed = "Closed",
  Corrected = "Corrected",
  NotesGenerated = "NotesGenerated",
  CertificatesGenerated = "CertificatesGenerated",
}
